import * as dataDownload from '../services/dataDownload';

export default {
  namespace: 'dataDownload',
  state: {},
  effects: {
    //下载数据列表
    *getDownloadDataList({ payload: { values }, callback }, { call, put }) {
      const response = yield call(dataDownload.getDownloadDataList, values);
      yield put({
        type: 'save',
        payload: {
          downloadDataList: response?.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    //可选年份列表
    *getYearList({ payload: { values }, callback }, { call, put }) {
      const response = yield call(dataDownload.getYearList, values);
      yield put({
        type: 'save',
        payload: {
          canDownloadYearList: response?.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },
};
